import React, { useEffect, useState } from "react";
import axios from "axios";
import TronWeb from "tronweb";
import coinGecko from "../../assets/js/coinGecko";
import CharryConverter from "../../assets/js/conversionCharry"
import Utils from "../../utils/index";
import companyLogo from '../../assets/images/logo.png';
import "./css/Payment.css";

var CryptoJS = require("crypto-js");

const ICO_CONTRACT_ADDRESS = process.env.REACT_APP_ICO_CONTRACT_ADDRESS;
const TRON_API = process.env.REACT_APP_TRON_API;
let tronWebMob;

const PaymentSuccess = () => {

    const [charrysent, setCharrySent] = useState(false)
    const [error, setError] = useState(0)

    useEffect(() => {

        const sendCharry = async () => {
            setCharrySent(false)
            const ciphertext = decodeURIComponent(window.location.pathname.slice(16))
            const bytes = CryptoJS.AES.decrypt(ciphertext, process.env.REACT_APP_DECRYPT_SECRET);
            const plaintext = JSON.parse(bytes.toString(CryptoJS.enc.Utf8)).msg


            if (plaintext) {

                const orderId = plaintext.slice(0, 36)
                let txnAmt;
                if (window.localStorage.getItem('CurrentCurrency') === 'inr') {
                    txnAmt = plaintext.slice(36, -3)
                } else {
                    txnAmt = plaintext.slice(36)
                }


                axios.defaults.withCredentials = false
                const HttpProvider = TronWeb.providers.HttpProvider;

                console.log(TRON_API)

                const fullNode = new HttpProvider(TRON_API)
                const solidityNode = new HttpProvider(TRON_API)
                const eventServer = TRON_API

                tronWebMob = new TronWeb(
                    fullNode,
                    solidityNode,
                    eventServer,
                    process.env.REACT_APP_ADMIN_PRIVATE_KEY
                );

                await Utils.setTronWeb(tronWebMob, ICO_CONTRACT_ADDRESS);

                const orderComplete = await Utils.contract.getOrderId(orderId).call()

                if (orderComplete) {
                    setCharrySent(true)
                } else {
                    let trxPriceData
                    if (window.localStorage.getItem('CurrentCurrency') === 'inr') {
                        trxPriceData = await coinGecko.get("/coins/markets", {
                            params: {
                                vs_currency: "inr",
                                ids: "tron"
                            }
                        })
                    } else {
                        trxPriceData = await coinGecko.get("/coins/markets", {
                            params: {
                                vs_currency: "usd",
                                ids: "tron"
                            }
                        })
                    }


                    const charryAmt = (txnAmt / trxPriceData.data[0].current_price).toFixed(2)
                    const numTokens = CharryConverter.fromCharry(charryAmt)
                    const userWalletAddress = window.localStorage.getItem('account')

                    console.log(numTokens)
                    console.log(userWalletAddress)
                    console.log(orderId)

                    await Utils.contract
                        .directInvest(userWalletAddress, numTokens, orderId)
                        .send({
                            shouldPollResponse: true,
                        })
                        .then((hash) => {
                            console.log("Transaction successful")
                            setCharrySent(true)
                        })
                        .catch((err) => {

                            if (err.error === "Cannot find result in solidity node") {
                                console.log("Transaction successful")
                                setCharrySent(true)
                            } else {
                                console.log(err)
                                console.log("Sorry Transaction Failed.");
                            }

                        });

                }



            } else {
                setError(404)
            }





        }

        sendCharry()

    }, [])

    const toICO = () => {
        window.location.href = "/"
    }

    const renderfooter = () => {
        if (charrysent === false) {
            return (
                <>
                    <div className="spinner-border text-warning spinner-padder" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-padder">Sending Charry...</div>
                    <div className="spinner-padder"><em>**Do NOT go back or press refresh. This may take several minutes....</em></div>
                </>
            )
        } else {
            return (
                <>
                    <button onClick={toICO} className="me-btn">Back To ICO</button>
                    <button className="me-btn">Official Website</button>
                </>
            )
        }
    }

    if (error === 404) {
        return (
            <div>Error: {error} Forbidden</div>
        )
    }

    return (
        <>
            <div className="payment-wrapper d-flex align-items-center min-vh-100">
                <div className="container text-center fluid">
                    <img src={companyLogo} alt="logo" className="img-fluid" />
                    <h4 className="payment-title-success"><b>PAYMENT SUCCESSFUL</b></h4>
                    <div className="progress">
                        <ul>
                            <li>
                                <i className="fas fa-check align-items-center justify-content-center done"></i>
                                <p>PAYMENT SUCCESSFUL</p>
                            </li>
                            <li>
                                <i className={charrysent === true ? "fas fa-check align-items-center justify-content-center done" : "fas fa-sync-alt align-items-center justify-content-center pending"}></i>
                                <p>CHARRY TOKENS SENT</p>
                            </li>
                            <li>
                                <i className={charrysent === true ? "fas fa-check align-items-center justify-content-center done" : "fas fa-circle align-items-center justify-content-center"}></i>
                                <p>TRANSACTION DONE</p>
                            </li>
                        </ul>
                    </div>
                    {renderfooter()}
                </div>
            </div>
        </>
    )

}

export default PaymentSuccess;